import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { useInvalidateClientProfile } from './get-client-profile'

type UpdateClientKeylessSuspendRequest = {
  clientId: string
  isKeylessAccessSuspended: boolean
}

const updateClientKeylessSuspend = async (data: UpdateClientKeylessSuspendRequest) => {
  const response = await authAPI.put(`/client/${data.clientId}`, {
    isKeylessAccessSuspended: data.isKeylessAccessSuspended,
  })
  return response.data
}

export const useUpdateClientKeylessSuspend = (clientId: string) => {
  const invalidate = useInvalidateClientProfile(clientId)
  return useMutation({
    mutationFn: updateClientKeylessSuspend,
    onSuccess: invalidate,
  })
}
